import { render, staticRenderFns } from "./batch-form-tm.vue?vue&type=template&id=74273088&scoped=true&"
import script from "./batch-form-tm.vue?vue&type=script&lang=js&"
export * from "./batch-form-tm.vue?vue&type=script&lang=js&"
import style0 from "./batch-form-tm.vue?vue&type=style&index=0&id=74273088&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74273088",
  null
  
)

component.options.__file = "batch-form-tm.vue"
export default component.exports